const Tdata = [
    {
      cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/top/category-2.png",
      para: "headphone",
      desc: "3k orders this week",
    },
    {
      cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/top/category-3.png",
      para: "watch",
      desc: "4k orders this week",
    },
    {
      cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/top/category-1.png",
      para: "sunglass",
      desc: "6k orders this week",
    },
    {
      cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/top/category-2.png",
      para: "watch",
      desc: "4k orders this week",
    },
    {
      cover: "https://648e99873722947deac636f5--sage-dusk-64ff08.netlify.app/images/top/category-3.png",
      para: "sunglass",
      desc: "6k orders this week",
    },
  ]
  
  export default Tdata